import { useState, type ReactNode } from 'react';
import { cn } from '../foundation/cn';

export interface TooltipProps {
  readonly content: ReactNode;
  readonly side?: 'top' | 'bottom';
  readonly children: ReactNode;
}

// CSS-positioned tooltip revealed on hover/focus. Content must be short; no collision
// handling in the foundation.
export function Tooltip({ content, side = 'top', children }: TooltipProps): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <span
      className="relative inline-flex"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open && (
        <span
          role="tooltip"
          className={cn(
            'absolute left-1/2 z-tooltip -translate-x-1/2 whitespace-nowrap rounded-sm bg-fg px-2 py-1 text-xs text-bg shadow-e2',
            side === 'top' ? 'bottom-full mb-1' : 'top-full mt-1',
          )}
        >
          {content}
        </span>
      )}
    </span>
  );
}
